module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "partnum"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "p01"
    }
  }), _vm._v("Part One")]), _vm._v(" "), _c('h1', {
    staticClass: "parttitle"
  }, [_vm._v("Exceptional Leaders Own the Accelerator")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "sidebartitle"
  }, [_c('b', [_c('i', [_vm._v("Immutable Law of Speed #1")])])]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_c('b', [_c('i', [_vm._v("You own the accelerator for the speed of your own work and the work of those you lead.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2aedafea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/07_part01.vue
// module id = 75
// module chunks = 0